<template>
  <div class="order-store">
    <van-checkbox @change="change" style="padding-right: 0.36rem;" v-if="showCheckbox" v-model="store.checked" icon-size="0.36rem" checked-color="#E1244E" />
    <img @click.stop="goStore" :src="store.avatar || $store.state.defaultAvatar" alt="">
    <p @click.stop="goStore">{{ store.nick_name }} <van-icon v-if="click" name="arrow" color="#AEAEAE" /></p>
    <div style="flex: 1"></div>
    <span v-if="statusText">{{ statusText }}</span>
  </div>
</template>

<script>
export default {
  name: 'order-store',
  props: {
    store: {
      type: Object,
      default() {
        return {}
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    statusText: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    click: {
      type: Boolean,
      default: true
    }
  },
  beforeDestroy() {
    this.$off('toggleStore')
  },
  methods: {
    goStore() {
      if (!this.click) return
      this.$router.push('/stores/' + this.store.id)
    },
    change() {
      this.$emit('toggleStore', { index: this.index })
    }
  }
}
</script>

<style scoped lang="stylus">
.order-store
  display flex
  align-items center
  margin-bottom 40px
  &>img
    width 47px
    height 47px
    margin-right 16px
    border-radius 50%
  &>p
    display flex
    align-items center
    font-size 30px
    color #010101
    ::v-deep
      &>i
        font-size 20px
        margin-left 20px
  &>span
    color #FD255C
    font-size 24px
</style>
